export default function searchTicket(state = "", action) {
	switch (action.type) {
		case "SEARCH_ITEM":
			return action.searchText;
		default:
			return state;
	}
}
